<template>
  <div ref="imageContainer" class="image-container">
    <!-- VIDEO EN LUGAR DE IMAGEN -->
    <video
      ref="videoRef"
      src="@/assets/daira-save-the-dtae_iOH6zJx8.mp4"
      class="cover-video render-gpu"
      autoplay
      loop
      muted
      playsinline
      webkit-playsinline
      preload="auto"
    ></video>
    
    <!-- Capa de oscurecimiento animada (SOLO ABAJO) -->
    <div ref="overlayRef" class="overlay"></div>
    
    <!-- Texto de la Firma -->
    <div ref="textRef" class="text-overlay">
      <p class="firma">
        Con cariño,<br>
        <span class="nombre-firma">Daira Jacqueline </span>
      </p>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'CoverVideoComponent',
  setup() {
    const videoRef = ref(null)
    const textRef = ref(null)
    const overlayRef = ref(null)
    const imageContainer = ref(null)
    let ctx = null

    // Forzar reproducción de video ante cualquier toque/clic en la pantalla
    const handleUserInteraction = () => {
      if (videoRef.value && videoRef.value.paused) {
        videoRef.value.play().catch(() => {})
      }
    }

    onMounted(() => {
      // Habilitar escuchadores de interacción global para desbloquear el autoplay en móviles
      window.addEventListener('touchstart', handleUserInteraction, { once: true, passive: true })
      window.addEventListener('click', handleUserInteraction, { once: true, passive: true })

      ctx = gsap.context(() => {
        gsap.config({ force3D: true })

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: imageContainer.value,
            start: 'top 88%',
            toggleActions: 'play none none none',
            once: true
          },
          defaults: { ease: 'power2.out', force3D: true }
        })

        // 1. Entrada fluida del Video (Sin `filter: blur()` que sobrecalienta la GPU)
        tl.fromTo(
          videoRef.value,
          {
            autoAlpha: 0,
            scale: 1.08,
            y: 20
          },
          {
            autoAlpha: 1,
            scale: 1,
            y: 0,
            duration: 1.0
          }
        )

        // 2. Oscurecimiento progresivo inferior para legibilidad
        .fromTo(
          overlayRef.value,
          { autoAlpha: 0 },
          { autoAlpha: 1, duration: 0.8 },
          '-=0.6'
        )

        // 3. Revelado limpio de la Firma
        .fromTo(
          textRef.value,
          {
            autoAlpha: 0,
            y: 20
          },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.8
          },
          '-=0.5'
        )
      }, imageContainer.value)

      setTimeout(() => {
        ScrollTrigger.refresh()
      }, 300)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
      window.removeEventListener('touchstart', handleUserInteraction)
      window.removeEventListener('click', handleUserInteraction)
    })

    return { 
      textRef, 
      videoRef, 
      overlayRef, 
      imageContainer 
    }
  }
}
</script>

<style scoped>
.image-container {
  width: 100%;
  height: 690px !important;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.cover-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}

/* Degradado inferior */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 40%,
    rgba(0, 0, 0, 0.7) 100%
  );
  z-index: 2;
}

.text-overlay {
  position: relative;
  z-index: 10;
  width: 100%;
  text-align: center;
  color: #ffffff;
  padding: 0 20px 32px;
  box-sizing: border-box;
}

.firma {
  font-size: 16px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 300;
  letter-spacing: 2px;
  line-height: 1.4;
  margin: 0;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
}

.nombre-firma {
  display: block;
  margin-top: 8px;
  font-family: 'british', cursive;
  font-size: 19px !important;
  color: #ffffff;
  line-height: 1.1;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.6);
}

/* Aceleración estricta por Hardware */
.render-gpu {
  will-change: transform, opacity;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}

@media (max-width: 480px) {
  .image-container {
    height: 520px;
  }
  .nombre-firma {
    font-size: 44px;
  }
}
</style>